import {Controller} from "../controller";
import {LazyLoad} from "./lazyload";

export interface IParams {
    name: string;
    value: string;
}

export interface ICollection {
    [key: string]: any;
}

export abstract class RecursosController extends Controller {

    /* INSTANCE */
    protected resources: HTMLElement[];
    protected scrollEvent: any;
    protected lazyInstance: LazyLoad;
    protected providerItems: ICollection;
    public static instances: any = [];

    /* STATIC */
    public static override async build(): Promise<void> {
    }

    protected constructor() {
        super();
        this.providerItems = {};
        this.resources = [];
        this.lazyInstance = new LazyLoad();
        this.lazyInstance.setPixels(1000);
    }

    protected async initPromises(urls: IParams[]): Promise<any> {
        const promesas = [];
        for (let url of urls) promesas.push(this.loadLibrary(url));
        return promesas;
    }

    protected async loadLibrary(params: IParams): Promise<any> {
        return new Promise<void>((resolve: any, reject: any) => {
            if (document.getElementById(params.name) === null) {
                const script = document.createElement("script") as HTMLScriptElement;
                script.id = params.name;
                script.src = params.value;
                script.async = true;
                script.addEventListener('load', resolve);
                script.addEventListener('error', reject);
                document.head.appendChild(script);
            } else {
                resolve();
            }
        });
    }

    protected async init(): Promise<void> {
        this.resources = this.resources.filter((item) => {
            if (this.lazyInstance.isInViewport(item)) {
                this.load(item);
                return;
            }
            return item;
        });
    }

    protected async lazyResources(): Promise<void> {
        if (this.resources.length === 0) {
            console.log("No resources")
            document.removeEventListener("scroll", this.scrollEvent);
            return;
        }
        let item = await this.lazyInstance.lazy(this.resources);
        if (item !== undefined) {
            this.resources = this.resources.filter((el) => {
                return el !== item;
            });
            await this.load(item);
        }
    }

    public async forceResources(html: HTMLElement): Promise<void> {
        let addScrollEvent = false;
        if (this.resources.length === 0) addScrollEvent = true;
        await this.getResources(html);
        if (this.resources.length > 0) {
            if (addScrollEvent) document.addEventListener("scroll", this.scrollEvent);
            document.dispatchEvent(new Event("scroll"));
        }
    }

    public async reLaunch(contenido: HTMLElement): Promise<void> {
        this.getResources(contenido).then(async()=>{
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected abstract load(item: HTMLElement): Promise<void>;

    protected abstract getResources(html: HTMLElement): Promise<void>;

}
